<p>&nbsp;</p>
<h4>{{'properties.self' | translate}}</h4>

<ul>
    <li *ngFor="let p of translatedProperties" (click)="showPropertyForm(p.dtype, p.dtype)" class="cursor-pointer">
        {{ p?.dtypeLabel || p?.dtype }}
    </li>
</ul>
